export interface PaymentWithCardOnFileResponseDto {
  redirectionUrl: string;
  success: boolean;
  /**
   * result is returned from the BOIPA API
   */
  result: any;
}
